import Stack from "@mui/material/Stack";
import { ContentBlocksModuleLayout } from "entities/modules/types";
import { useGeneralData } from "modules/brands/pages/ModulesContainer/components/PageModules/components/ModuleDetailsDrawer/stores/useGeneralData";
import React, { type FC, ReactNode } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import OneCardBlockConfig from "./components/OneCardBlockConfig";
import TextBlockForm from "./components/TextBlockForm";
import ThreeCardBlocksConfig from "./components/ThreeCardBlocksConfig";

const moduleConfigurationView: Record<
  ContentBlocksModuleLayout,
  ReactNode | null
> = {
  [ContentBlocksModuleLayout.ThreeCardBlock]: <ThreeCardBlocksConfig />,
  [ContentBlocksModuleLayout.TextBlock]: <TextBlockForm />,
  [ContentBlocksModuleLayout.OneCardBlock]: <OneCardBlockConfig />,
};

const ModuleConfigurationSection: FC = () => {
  const { moduleLayout, contentBlocks } = useGeneralData();
  if (!contentBlocks || !moduleLayout) {
    return null;
  }

  return (
    <ContentSection title="Module Configuration">
      <Stack spacing="1.5rem">
        {moduleLayout
          ? moduleConfigurationView[moduleLayout as ContentBlocksModuleLayout]
          : null}
      </Stack>
    </ContentSection>
  );
};

export default ModuleConfigurationSection;
